import { render } from "./Recommendation&ComplianceMatrix.vue?vue&type=template&id=84c08ea6"
import script from "./Recommendation&ComplianceMatrix.vue?vue&type=script&lang=js"
export * from "./Recommendation&ComplianceMatrix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__